export default "__VITE_ASSET__6fc8fd89__"